import type { HoaAppConfig } from "@hoalaw/ui";
import { productConfig } from "@/config/product";

export const appConfig: HoaAppConfig = {
  state: "fl",
  brand: "FloridaHOALaw.ai",
  emoji: "🌴",
  logoSrc: "/logo.svg",
  navTheme: "blue-orange",
  topicsUrl: "https://www.floridahoalaw.ai/topics/",
  topicsDeployed: true,
  toolsUrl: "/tools/",
  toolsDeployed: true,
  // Public product pages in the footer's Product column. Mirrors livePages in
  // seo/src/data/product-pages.ts (src/config/__tests__/productPages.test.ts checks it).
  productLinks: [
    { label: "How It Works", href: "/how-it-works/" },
    { label: "Ask Your HOA Documents", href: "/ask-your-hoa-documents/" },
    { label: "Document Review", href: "/document-review/" },
  ],
  educationUrl: "/education/",
  educationDeployed: true,
  aboutUrl: "/about/",
  aboutDeployed: true,
  contactEmail: "rei+contact@floridahoalaw.ai",
  lawRefs: "Florida Statutes Chapters 718 and 720",
  attorney: "Florida",
  adminPath: productConfig.admin.adminPath,
};

/** The law answer source as users see it: "Answer using: Florida Law", "compare with Florida law". */
export const LAW_SOURCE_LABEL = "Florida Law";
